import isObject from 'lodash/isPlainObject';
// A generic reducer with scoped strings, only meant to be used once,
// So there's not additional meta or nested data,
// and it's auto initialized with the parent reducer

// TODO: Update unireducer to have a standard key attachment, incl tests
const Unireducer = (scopeString, blankInitState) => {
    let finalBlankState = blankInitState;
    if (isObject(blankInitState)) {
        finalBlankState = Object.assign({}, blankInitState);
    }
    return (state = finalBlankState, { type, payload }) => {
        //If not related to this unireducer at all, return out
        if (!type || !type.includes(scopeString)) return state;

        if (!payload) payload = {};

        if (isObject(blankInitState) && isObject(payload)) {
            // Update only the keys given in the finalBlankState
            // so random crap doesn't get saved
            // NOTE: if you initialize with a Primitive, this won't work!
            for (const key in payload) {
                if (!Object.keys(finalBlankState).includes(key)) {
                    console.error(
                        `Invalid key ${key} in payload. State not updated for ${scopeString}`
                    );
                    return state;
                }
            }
        }

        if (type === `${scopeString}/CHANGE`) {
            //If it's a primitive, just reassign
            if (!isObject(payload)) return payload;
            //If it's an object, do a shallow merge
            return Object.assign({}, state, payload);
        }

        if (type === `${scopeString}/CLEAR`) {
            return finalBlankState;
        }

        console.error(`Unknown action: ${type}. Returning state.`);

        return state;
    };
};
export default Unireducer;
